"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (e) {
  return e && e.preventDefault && e.preventDefault();
};


//////////////////
// WEBPACK FOOTER
// ./~/redux-first-router-link/dist/preventDefault.js
// module id = 1075
// module chunks = 2